import { render, staticRenderFns } from "./labelsTemplate.vue?vue&type=template&id=de061250&"
import script from "./labelsTemplate.vue?vue&type=script&lang=js&"
export * from "./labelsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./labelsTemplate.vue?vue&type=style&index=0&id=de061250&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports